export default {
  items: [
    {
      name: 'Dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'success',
        text: 'NEW'
      },
      children: [
        {
          name: 'Admin DB',
          url: '/admin-db',
          icon: 'icon-options'
        },
        {
          name: 'Field Data',
          url: '/field-master-data',
          icon: 'icon-options'
        },
        {
          name: 'Email Sender',
          url: '/email-sender',
          icon: 'icon-options'
        },
        {
          name: 'Report Issue',
          url: '/report-issue',
          icon: 'icon-options'
        },
        {
          name: 'Documentation',
          url: '/docs',
          icon: 'icon-options'
        },
        {
          name: 'Upload File',
          url: '/upload-file',
          icon: 'icon-options'
        }
      ]
    },
    {
      name: 'User Management',
      icon: 'icon-people',
      children: [
        {
          name: 'List User',
          url: '/users/list',
          icon: 'icon-options'
        },
        {
          name: 'Import User',
          url: '/users/import',
          icon: 'icon-options'
        }
      ]
    },
    {
      name: 'Contractors',
      icon: 'icon-docs',
      children: [
        {
          name: 'Approved List',
          url: '/contractors/list-approved',
          icon: 'icon-options'
        },
        {
          name: 'Need Approved (new)',
          url: '/contractors/list-not-approved',
          icon: 'icon-options'
        },
        {
          name: 'Need Approved (update)',
          url: '/contractors/list-not-approved-update',
          icon: 'icon-options'
        },
        {
          name: 'Import Contractors',
          url: '/contractors/import',
          icon: 'icon-options',
        }
      ]
    },
    {
      name: 'Projects',
      icon: 'icon-layers',
      children: [
        {
          name: 'Approved List',
          url: '/projects/list-approved',
          icon: 'icon-options'
        },
        {
          name: 'Need Approved (new)',
          url: '/projects/list-not-approved',
          icon: 'icon-options'
        },
        {
          name: 'Need Approved (update)',
          url: '/projects/list-not-approved-update',
          icon: 'icon-options'
        },
        {
          name: 'Import Projects',
          url: '/projects/import',
          icon: 'icon-options',
        }
      ]
    },
    {
      name: 'Bidding',
      icon: 'icon-people',
      children: [
        {
          name: 'Approved List',
          url: '/bidding/list-approved',
          icon: 'icon-options'
        },
        {
          name: 'Need Approved (new)',
          url: '/bidding/list-not-approved',
          icon: 'icon-options'
        },
        {
          name: 'Need Approved (update)',
          url: '/bidding/list-not-approved-update',
          icon: 'icon-options'
        }
      ]
    },
    {
      name: 'Contacts',
      icon: 'icon-people',
      children: [
        {
          name: 'List Contact',
          url: '/contacts/list',
          icon: 'icon-options'
        },
        {
          name: 'Import Contact',
          url: '/contacts/import',
          icon: 'icon-options'
        }
      ]
    },
    {
      name: 'Shop',
      icon: 'icon-handbag',
      children: [
        {
          name: 'Orders Waiting',
          url: '/orders/waiting',
          icon: 'icon-options',
        },
        {
          name: 'Orders Completed',
          url: '/orders/completed',
          icon: 'icon-options'
        },
        {
          name: 'Orders In Process',
          url: '/orders/in-process',
          icon: 'icon-options'
        },
        {
          name: 'Orders Charge Failed',
          url: '/orders/failed-to-charge',
          icon: 'icon-options'
        },
        {
          name: 'Orders Canceled',
          url: '/orders/canceled',
          icon: 'icon-options'
        },
        {
          name: 'Orders Shipped',
          url: '/orders/shipped',
          icon: 'icon-options'
        },
      ]
    },
  ]
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/_nav.js